const LIST_SERIES_VEHICLE = [
  {
    key: '',
    value: '',
    label: 'Seri',
    parent: '',
  },
  {
    key: '1704',
    value: 'A3',
    label: 'A3',
    parent: '1700',
  },
  {
    key: '1701',
    value: 'A4',
    label: 'A4',
    parent: '1700',
  },
  {
    key: '1702',
    value: 'A6',
    label: 'A6',
    parent: '1700',
  },
  {
    key: '1706',
    value: 'A7',
    label: 'A7',
    parent: '1700',
  },
  {
    key: '1707',
    value: 'A8',
    label: 'A8',
    parent: '1700',
  },
  {
    key: '1705',
    value: 'ALLROAD TURBO QUATTRO',
    label: 'ALLROAD TURBO QUATTRO',
    parent: '1700',
  },
  {
    key: '1708',
    value: 'Q7',
    label: 'Q7',
    parent: '1700',
  },
  {
    key: '1703',
    value: 'TT',
    label: 'TT',
    parent: '1700',
  },
  {
    key: '1752',
    value: 'ARYA',
    label: 'ARYA',
    parent: '1747',
  },
  {
    key: '1750',
    value: 'CAKRA',
    label: 'CAKRA',
    parent: '1747',
  },
  {
    key: '1751',
    value: 'NENGGALA',
    label: 'NENGGALA',
    parent: '1747',
  },
  {
    key: '1787',
    value: '116I',
    label: '116I',
    parent: '1748',
  },
  {
    key: '1786',
    value: '120I',
    label: '120I',
    parent: '1748',
  },
  {
    key: '1759',
    value: '318I',
    label: '318I',
    parent: '1748',
  },
  {
    key: '1760',
    value: '320I',
    label: '320I',
    parent: '1748',
  },
  {
    key: '1764',
    value: '323CI',
    label: '323CI',
    parent: '1748',
  },
  {
    key: '1761',
    value: '323I',
    label: '323I',
    parent: '1748',
  },
  {
    key: '1763',
    value: '325CI',
    label: '325CI',
    parent: '1748',
  },
  {
    key: '1762',
    value: '325I',
    label: '325I',
    parent: '1748',
  },
  {
    key: '1765',
    value: '328CI',
    label: '328CI',
    parent: '1748',
  },
  {
    key: '1766',
    value: '330CI',
    label: '330CI',
    parent: '1748',
  },
  {
    key: '1767',
    value: '330I',
    label: '330I',
    parent: '1748',
  },
  {
    key: '1770',
    value: '520I',
    label: '520I',
    parent: '1748',
  },
  {
    key: '1771',
    value: '523I',
    label: '523I',
    parent: '1748',
  },
  {
    key: '1772',
    value: '525I',
    label: '525I',
    parent: '1748',
  },
  {
    key: '1773',
    value: '528I',
    label: '528I',
    parent: '1748',
  },
  {
    key: '1774',
    value: '530I',
    label: '530I',
    parent: '1748',
  },
  {
    key: '1775',
    value: '630I',
    label: '630I',
    parent: '1748',
  },
  {
    key: '1776',
    value: '645CI',
    label: '645CI',
    parent: '1748',
  },
  {
    key: '1777',
    value: '728I',
    label: '728I',
    parent: '1748',
  },
  {
    key: '1778',
    value: '730I',
    label: '730I',
    parent: '1748',
  },
  {
    key: '1779',
    value: '735I',
    label: '735I',
    parent: '1748',
  },
  {
    key: '1780',
    value: '740I',
    label: '740I',
    parent: '1748',
  },
  {
    key: '1781',
    value: '745I',
    label: '745I',
    parent: '1748',
  },
  {
    key: '1782',
    value: '750LI',
    label: '750LI',
    parent: '1748',
  },
  {
    key: '1783',
    value: '760LI',
    label: '760LI',
    parent: '1748',
  },
  {
    key: '2371',
    value: 'X1',
    label: 'X1',
    parent: '1748',
  },
  {
    key: '1785',
    value: 'X3',
    label: 'X3',
    parent: '1748',
  },
  {
    key: '2659',
    value: 'X4',
    label: 'X4',
    parent: '1748',
  },
  {
    key: '1784',
    value: 'X5',
    label: 'X5',
    parent: '1748',
  },
  {
    key: '1788',
    value: 'X6',
    label: 'X6',
    parent: '1748',
  },
  {
    key: '1768',
    value: 'Z3',
    label: 'Z3',
    parent: '1748',
  },
  {
    key: '1769',
    value: 'Z4',
    label: 'Z4',
    parent: '1748',
  },
  {
    key: '1637',
    value: 'QQ',
    label: 'QQ',
    parent: '1625',
  },
  {
    key: '1638',
    value: 'TIGGO',
    label: 'TIGGO',
    parent: '1625',
  },
  {
    key: '1639',
    value: 'AVEO',
    label: 'AVEO',
    parent: '1626',
  },
  {
    key: '2330',
    value: 'BLAZER',
    label: 'BLAZER',
    parent: '1626',
  },
  {
    key: '1640',
    value: 'CAPTIVA',
    label: 'CAPTIVA',
    parent: '1626',
  },
  {
    key: '1641',
    value: 'COLORADO',
    label: 'COLORADO',
    parent: '1626',
  },
  {
    key: '2622',
    value: 'ESTATE',
    label: 'ESTATE',
    parent: '1626',
  },
  {
    key: '2318',
    value: 'LOVA',
    label: 'LOVA',
    parent: '1626',
  },
  {
    key: '2181',
    value: 'OPTRA',
    label: 'OPTRA',
    parent: '1626',
  },
  {
    key: '1642',
    value: 'SPARK',
    label: 'SPARK',
    parent: '1626',
  },
  {
    key: '1643',
    value: 'SPIN',
    label: 'SPIN',
    parent: '1626',
  },
  {
    key: '1865',
    value: 'TAVERA',
    label: 'TAVERA',
    parent: '1626',
  },
  {
    key: '3056',
    value: 'TRAX',
    label: 'TRAX',
    parent: '1626',
  },
  {
    key: '2119',
    value: 'ZAFIRA',
    label: 'ZAFIRA',
    parent: '1626',
  },
  {
    key: null,
    value: null,
    label: null,
    parent: '1749',
  },
  {
    key: '24',
    value: 'AYLA',
    label: 'AYLA',
    parent: '2',
  },
  {
    key: '357',
    value: 'CERIA',
    label: 'CERIA',
    parent: '2',
  },
  {
    key: '359',
    value: 'CLASSY',
    label: 'CLASSY',
    parent: '2',
  },
  {
    key: '360',
    value: 'ESPASS',
    label: 'ESPASS',
    parent: '2',
  },
  {
    key: '361',
    value: 'FEROZA',
    label: 'FEROZA',
    parent: '2',
  },
  {
    key: '314',
    value: 'GRAN MAX',
    label: 'GRAN MAX',
    parent: '2',
  },
  {
    key: '362',
    value: 'GRAND FEROZA',
    label: 'GRAND FEROZA',
    parent: '2',
  },
  {
    key: '1462',
    value: 'GREAT XENIA',
    label: 'GREAT XENIA',
    parent: '2',
  },
  {
    key: '1861',
    value: 'HIJET',
    label: 'HIJET',
    parent: '2',
  },
  {
    key: '2240',
    value: 'HIMAX',
    label: 'HIMAX',
    parent: '2',
  },
  {
    key: '37',
    value: 'LUXIO',
    label: 'LUXIO',
    parent: '2',
  },
  {
    key: '363',
    value: 'NEO ZEBRA',
    label: 'NEO ZEBRA',
    parent: '2',
  },
  {
    key: '2949',
    value: 'ROCKY',
    label: 'ROCKY',
    parent: '2',
  },
  {
    key: '2110',
    value: 'SIGRA',
    label: 'SIGRA',
    parent: '2',
  },
  {
    key: '27',
    value: 'SIRION',
    label: 'SIRION',
    parent: '2',
  },
  {
    key: '364',
    value: 'TAFT',
    label: 'TAFT',
    parent: '2',
  },
  {
    key: '365',
    value: 'TARUNA',
    label: 'TARUNA',
    parent: '2',
  },
  {
    key: '28',
    value: 'TERIOS',
    label: 'TERIOS',
    parent: '2',
  },
  {
    key: '23',
    value: 'XENIA',
    label: 'XENIA',
    parent: '2',
  },
  {
    key: '366',
    value: 'YRV',
    label: 'YRV',
    parent: '2',
  },
  {
    key: '367',
    value: 'ZEBRA',
    label: 'ZEBRA',
    parent: '2',
  },
  {
    key: '1644',
    value: 'GO PANCA',
    label: 'GO PANCA',
    parent: '1627',
  },
  {
    key: '1645',
    value: 'GO+ PANCA',
    label: 'GO+ PANCA',
    parent: '1627',
  },
  {
    key: '2078',
    value: 'JOURNEY',
    label: 'JOURNEY',
    parent: '2077',
  },
  {
    key: '2010',
    value: 'ECOSPORT',
    label: 'ECOSPORT',
    parent: '36',
  },
  {
    key: '765',
    value: 'ESCAPE',
    label: 'ESCAPE',
    parent: '36',
  },
  {
    key: '766',
    value: 'EVEREST',
    label: 'EVEREST',
    parent: '36',
  },
  {
    key: '767',
    value: 'EXPLORE',
    label: 'EXPLORE',
    parent: '36',
  },
  {
    key: '768',
    value: 'F',
    label: 'F',
    parent: '36',
  },
  {
    key: '1647',
    value: 'FIESTA',
    label: 'FIESTA',
    parent: '36',
  },
  {
    key: '769',
    value: 'FOCUS',
    label: 'FOCUS',
    parent: '36',
  },
  {
    key: '770',
    value: 'LASER',
    label: 'LASER',
    parent: '36',
  },
  {
    key: '771',
    value: 'LYNX',
    label: 'LYNX',
    parent: '36',
  },
  {
    key: '772',
    value: 'RANGER',
    label: 'RANGER',
    parent: '36',
  },
  {
    key: '773',
    value: 'TELSTAR',
    label: 'TELSTAR',
    parent: '36',
  },
  {
    key: '2643',
    value: 'AUMAN',
    label: 'AUMAN',
    parent: '2426',
  },
  {
    key: '2427',
    value: 'BJ1059',
    label: 'BJ1059',
    parent: '2426',
  },
  {
    key: '1648',
    value: 'MK1',
    label: 'MK1',
    parent: '1630',
  },
  {
    key: '2638',
    value: 'XML6127D52',
    label: 'XML6127D52',
    parent: '2637',
  },
  {
    key: '1432',
    value: 'DUTRO',
    label: 'DUTRO',
    parent: '1431',
  },
  {
    key: '2878',
    value: 'FB2WGLZ-EN',
    label: 'FB2WGLZ-EN',
    parent: '1431',
  },
  {
    key: '2997',
    value: 'FL 176 MA/NA',
    label: 'FL 176 MA/NA',
    parent: '1431',
  },
  {
    key: '2867',
    value: 'FL 235 JN',
    label: 'FL 235 JN',
    parent: '1431',
  },
  {
    key: '2671',
    value: 'FM226MD',
    label: 'FM226MD',
    parent: '1431',
  },
  {
    key: '2883',
    value: 'FM8JWIA-EGJ',
    label: 'FM8JWIA-EGJ',
    parent: '1431',
  },
  {
    key: '2415',
    value: 'JUMBO RANGER',
    label: 'JUMBO RANGER',
    parent: '1431',
  },
  {
    key: '2114',
    value: 'RANGER',
    label: 'RANGER',
    parent: '1431',
  },
  {
    key: '1789',
    value: 'RIGkey',
    label: 'RIGkey',
    parent: '1431',
  },
  {
    key: '487',
    value: 'ACCORD',
    label: 'ACCORD',
    parent: '5',
  },
  {
    key: '2000',
    value: 'ACCORD VTIL',
    label: 'ACCORD VTIL',
    parent: '5',
  },
  {
    key: '30',
    value: 'BRIO',
    label: 'BRIO',
    parent: '5',
  },
  {
    key: '1984',
    value: 'BRV',
    label: 'BRV',
    parent: '5',
  },
  {
    key: '1988',
    value: 'CARENS',
    label: 'CARENS',
    parent: '5',
  },
  {
    key: '31',
    value: 'CITY',
    label: 'CITY',
    parent: '5',
  },
  {
    key: '488',
    value: 'CIVIC',
    label: 'CIVIC',
    parent: '5',
  },
  {
    key: '32',
    value: 'CR-V',
    label: 'CR-V',
    parent: '5',
  },
  {
    key: '489',
    value: 'EDIX',
    label: 'EDIX',
    parent: '5',
  },
  {
    key: '490',
    value: 'ELYSION',
    label: 'ELYSION',
    parent: '5',
  },
  {
    key: '491',
    value: 'FIT',
    label: 'FIT',
    parent: '5',
  },
  {
    key: '1312',
    value: 'FREED',
    label: 'FREED',
    parent: '5',
  },
  {
    key: '574',
    value: 'FRONTIER',
    label: 'FRONTIER',
    parent: '5',
  },
  {
    key: '575',
    value: 'GENESIS',
    label: 'GENESIS',
    parent: '5',
  },
  {
    key: '492',
    value: 'HRV',
    label: 'HRV',
    parent: '5',
  },
  {
    key: '493',
    value: 'INTEGRA',
    label: 'INTEGRA',
    parent: '5',
  },
  {
    key: '29',
    value: 'JAZZ',
    label: 'JAZZ',
    parent: '5',
  },
  {
    key: '494',
    value: 'MDX',
    label: 'MDX',
    parent: '5',
  },
  {
    key: '1335',
    value: 'MOBILIO',
    label: 'MOBILIO',
    parent: '5',
  },
  {
    key: '495',
    value: 'ODYSSEY',
    label: 'ODYSSEY',
    parent: '5',
  },
  {
    key: '497',
    value: 'S 2000',
    label: 'S 2000',
    parent: '5',
  },
  {
    key: '498',
    value: 'STREAM',
    label: 'STREAM',
    parent: '5',
  },
  {
    key: '821',
    value: 'ACCENT',
    label: 'ACCENT',
    parent: '17',
  },
  {
    key: '822',
    value: 'ATOZ',
    label: 'ATOZ',
    parent: '17',
  },
  {
    key: '823',
    value: 'AVEGA',
    label: 'AVEGA',
    parent: '17',
  },
  {
    key: '824',
    value: 'AZERA',
    label: 'AZERA',
    parent: '17',
  },
  {
    key: '826',
    value: 'COUPE',
    label: 'COUPE',
    parent: '17',
  },
  {
    key: '827',
    value: 'ELANTRA',
    label: 'ELANTRA',
    parent: '17',
  },
  {
    key: '828',
    value: 'EXCEL',
    label: 'EXCEL',
    parent: '17',
  },
  {
    key: '829',
    value: 'EXCEL II',
    label: 'EXCEL II',
    parent: '17',
  },
  {
    key: '832',
    value: 'GETZ',
    label: 'GETZ',
    parent: '17',
  },
  {
    key: '831',
    value: 'GRACE',
    label: 'GRACE',
    parent: '17',
  },
  {
    key: '833',
    value: 'GRANDEUR',
    label: 'GRANDEUR',
    parent: '17',
  },
  {
    key: '1620',
    value: 'H-1',
    label: 'H-1',
    parent: '17',
  },
  {
    key: '3077',
    value: 'HD 125',
    label: 'HD 125',
    parent: '17',
  },
  {
    key: '2267',
    value: 'HD78',
    label: 'HD78',
    parent: '17',
  },
  {
    key: '1652',
    value: 'I 20',
    label: 'I 20',
    parent: '17',
  },
  {
    key: '834',
    value: 'I10',
    label: 'I10',
    parent: '17',
  },
  {
    key: '835',
    value: 'MATRIX',
    label: 'MATRIX',
    parent: '17',
  },
  {
    key: '836',
    value: 'MIGHTY',
    label: 'MIGHTY',
    parent: '17',
  },
  {
    key: '1650',
    value: 'PREGIO',
    label: 'PREGIO',
    parent: '17',
  },
  {
    key: '1651',
    value: 'R 220',
    label: 'R 220',
    parent: '17',
  },
  {
    key: '840',
    value: 'SANTA',
    label: 'SANTA',
    parent: '17',
  },
  {
    key: '841',
    value: 'SONATA',
    label: 'SONATA',
    parent: '17',
  },
  {
    key: '2442',
    value: 'STAREX',
    label: 'STAREX',
    parent: '17',
  },
  {
    key: '839',
    value: 'TRAJET',
    label: 'TRAJET',
    parent: '17',
  },
  {
    key: '843',
    value: 'TRUCK',
    label: 'TRUCK',
    parent: '17',
  },
  {
    key: '842',
    value: 'TUCSON',
    label: 'TUCSON',
    parent: '17',
  },
  {
    key: '2629',
    value: 'FX 50',
    label: 'FX 50',
    parent: '2628',
  },
  {
    key: '2229',
    value: 'BISON',
    label: 'BISON',
    parent: '4',
  },
  {
    key: '655',
    value: 'BLACK PANTHER',
    label: 'BLACK PANTHER',
    parent: '4',
  },
  {
    key: '656',
    value: 'BORNEO',
    label: 'BORNEO',
    parent: '4',
  },
  {
    key: '657',
    value: 'D-MAX',
    label: 'D-MAX',
    parent: '4',
  },
  {
    key: '658',
    value: 'E2',
    label: 'E2',
    parent: '4',
  },
  {
    key: '665',
    value: 'ELF',
    label: 'ELF',
    parent: '4',
  },
  {
    key: '2378',
    value: 'FRR 90 ',
    label: 'FRR 90 ',
    parent: '4',
  },
  {
    key: '2381',
    value: 'FTR 33',
    label: 'FTR 33',
    parent: '4',
  },
  {
    key: '2166',
    value: 'FVM',
    label: 'FVM',
    parent: '4',
  },
  {
    key: '2190',
    value: 'FVZ  34 P',
    label: 'FVZ  34 P',
    parent: '4',
  },
  {
    key: '704',
    value: 'GIGA',
    label: 'GIGA',
    parent: '4',
  },
  {
    key: '3031',
    value: 'KK-FRR35K3S',
    label: 'KK-FRR35K3S',
    parent: '4',
  },
  {
    key: '3029',
    value: 'KK-NRR35K3',
    label: 'KK-NRR35K3',
    parent: '4',
  },
  {
    key: '1806',
    value: 'MU-X',
    label: 'MU-X',
    parent: '4',
  },
  {
    key: '659',
    value: 'NEW PANTHER',
    label: 'NEW PANTHER',
    parent: '4',
  },
  {
    key: '2103',
    value: 'NPS 75',
    label: 'NPS 75',
    parent: '4',
  },
  {
    key: '660',
    value: 'PANTHER',
    label: 'PANTHER',
    parent: '4',
  },
  {
    key: '3067',
    value: 'TRAGA',
    label: 'TRAGA',
    parent: '4',
  },
  {
    key: '2661',
    value: 'S TYPE V6',
    label: 'S TYPE V6',
    parent: '2660',
  },
  {
    key: '3103',
    value: 'RUBICON',
    label: 'RUBICON',
    parent: '2971',
  },
  {
    key: '2972',
    value: 'WRANGLER',
    label: 'WRANGLER',
    parent: '2971',
  },
  {
    key: '1989',
    value: 'CARENS',
    label: 'CARENS',
    parent: '1632',
  },
  {
    key: '2250',
    value: 'CARNIVAL',
    label: 'CARNIVAL',
    parent: '1632',
  },
  {
    key: '1653',
    value: 'PICANTO',
    label: 'PICANTO',
    parent: '1632',
  },
  {
    key: '1655',
    value: 'PREGIO',
    label: 'PREGIO',
    parent: '1632',
  },
  {
    key: '1654',
    value: 'RIO',
    label: 'RIO',
    parent: '1632',
  },
  {
    key: '2004',
    value: 'RIO HATCHBACK',
    label: 'RIO HATCHBACK',
    parent: '1632',
  },
  {
    key: '2257',
    value: 'SEDONA',
    label: 'SEDONA',
    parent: '1632',
  },
  {
    key: '1656',
    value: 'SPORTAGE',
    label: 'SPORTAGE',
    parent: '1632',
  },
  {
    key: '1657',
    value: 'TRAVELLO',
    label: 'TRAVELLO',
    parent: '1632',
  },
  {
    key: '2165',
    value: 'VISTO',
    label: 'VISTO',
    parent: '1632',
  },
  {
    key: '2483',
    value: 'GALLARDO',
    label: 'GALLARDO',
    parent: '2482',
  },
  {
    key: '3048',
    value: 'GS 300',
    label: 'GS 300',
    parent: '2355',
  },
  {
    key: '2356',
    value: 'LS460L',
    label: 'LS460L',
    parent: '2355',
  },
  {
    key: '3044',
    value: 'LX 570',
    label: 'LX 570',
    parent: '2355',
  },
  {
    key: '2584',
    value: 'RX 300',
    label: 'RX 300',
    parent: '2355',
  },
  {
    key: '3041',
    value: 'RX 350',
    label: 'RX 350',
    parent: '2355',
  },
  {
    key: '2491',
    value: 'RX270',
    label: 'RX270',
    parent: '2355',
  },
  {
    key: '2015',
    value: '400 HP',
    label: '400 HP',
    parent: '2013',
  },
  {
    key: '2014',
    value: '480 HP',
    label: '480 HP',
    parent: '2013',
  },
  {
    key: '1424',
    value: '2',
    label: '2',
    parent: '19',
  },
  {
    key: '953',
    value: '3',
    label: '3',
    parent: '19',
  },
  {
    key: '937',
    value: '323',
    label: '323',
    parent: '19',
  },
  {
    key: '2399',
    value: '5',
    label: '5',
    parent: '19',
  },
  {
    key: '949',
    value: '6',
    label: '6',
    parent: '19',
  },
  {
    key: '938',
    value: '626',
    label: '626',
    parent: '19',
  },
  {
    key: '2633',
    value: '8',
    label: '8',
    parent: '19',
  },
  {
    key: '946',
    value: 'B-2500',
    label: 'B-2500',
    parent: '19',
  },
  {
    key: '1947',
    value: 'BIANTE',
    label: 'BIANTE',
    parent: '19',
  },
  {
    key: '952',
    value: 'BT-50',
    label: 'BT-50',
    parent: '19',
  },
  {
    key: '2041',
    value: 'CX-5',
    label: 'CX-5',
    parent: '19',
  },
  {
    key: '950',
    value: 'CX-7',
    label: 'CX-7',
    parent: '19',
  },
  {
    key: '951',
    value: 'CX-9',
    label: 'CX-9',
    parent: '19',
  },
  {
    key: '939',
    value: 'E-2000',
    label: 'E-2000',
    parent: '19',
  },
  {
    key: '948',
    value: 'MAZDA3',
    label: 'MAZDA3',
    parent: '19',
  },
  {
    key: '944',
    value: 'MPV',
    label: 'MPV',
    parent: '19',
  },
  {
    key: '940',
    value: 'MR 90',
    label: 'MR 90',
    parent: '19',
  },
  {
    key: '943',
    value: 'PREMACY',
    label: 'PREMACY',
    parent: '19',
  },
  {
    key: '947',
    value: 'RX8',
    label: 'RX8',
    parent: '19',
  },
  {
    key: '945',
    value: 'TRIBUTE',
    label: 'TRIBUTE',
    parent: '19',
  },
  {
    key: '942',
    value: 'VANTREND',
    label: 'VANTREND',
    parent: '19',
  },
  {
    key: '2601',
    value: 'VX-1',
    label: 'VX-1',
    parent: '19',
  },
  {
    key: '2368',
    value: '1521',
    label: '1521',
    parent: '3',
  },
  {
    key: '993',
    value: 'A 140',
    label: 'A 140',
    parent: '3',
  },
  {
    key: '994',
    value: 'A 150',
    label: 'A 150',
    parent: '3',
  },
  {
    key: '995',
    value: 'A CLASS 160',
    label: 'A CLASS 160',
    parent: '3',
  },
  {
    key: '996',
    value: 'B 170',
    label: 'B 170',
    parent: '3',
  },
  {
    key: '2653',
    value: 'B 180',
    label: 'B 180',
    parent: '3',
  },
  {
    key: '997',
    value: 'C 180',
    label: 'C 180',
    parent: '3',
  },
  {
    key: '1004',
    value: 'C 200',
    label: 'C 200',
    parent: '3',
  },
  {
    key: '999',
    value: 'C 230',
    label: 'C 230',
    parent: '3',
  },
  {
    key: '1000',
    value: 'C 240',
    label: 'C 240',
    parent: '3',
  },
  {
    key: '2434',
    value: 'C 250',
    label: 'C 250',
    parent: '3',
  },
  {
    key: '1001',
    value: 'C 270',
    label: 'C 270',
    parent: '3',
  },
  {
    key: '1002',
    value: 'C 280',
    label: 'C 280',
    parent: '3',
  },
  {
    key: '2690',
    value: 'C 300',
    label: 'C 300',
    parent: '3',
  },
  {
    key: '1003',
    value: 'C 320',
    label: 'C 320',
    parent: '3',
  },
  {
    key: '1006',
    value: 'CLK 230',
    label: 'CLK 230',
    parent: '3',
  },
  {
    key: '1007',
    value: 'CLK 240',
    label: 'CLK 240',
    parent: '3',
  },
  {
    key: '1008',
    value: 'CLK 320',
    label: 'CLK 320',
    parent: '3',
  },
  {
    key: '1010',
    value: 'CLS 350',
    label: 'CLS 350',
    parent: '3',
  },
  {
    key: '1011',
    value: 'E 200',
    label: 'E 200',
    parent: '3',
  },
  {
    key: '1012',
    value: 'E 220',
    label: 'E 220',
    parent: '3',
  },
  {
    key: '1013',
    value: 'E 230',
    label: 'E 230',
    parent: '3',
  },
  {
    key: '1014',
    value: 'E 240',
    label: 'E 240',
    parent: '3',
  },
  {
    key: '2646',
    value: 'E 250',
    label: 'E 250',
    parent: '3',
  },
  {
    key: '1015',
    value: 'E 260',
    label: 'E 260',
    parent: '3',
  },
  {
    key: '1016',
    value: 'E 280',
    label: 'E 280',
    parent: '3',
  },
  {
    key: '2148',
    value: 'E 300',
    label: 'E 300',
    parent: '3',
  },
  {
    key: '1018',
    value: 'E 320',
    label: 'E 320',
    parent: '3',
  },
  {
    key: '1022',
    value: 'EYES E 320',
    label: 'EYES E 320',
    parent: '3',
  },
  {
    key: '1019',
    value: 'JEEP LONG',
    label: 'JEEP LONG',
    parent: '3',
  },
  {
    key: '1020',
    value: 'ML 270',
    label: 'ML 270',
    parent: '3',
  },
  {
    key: '1021',
    value: 'ML 320',
    label: 'ML 320',
    parent: '3',
  },
  {
    key: '2451',
    value: 'ML 430',
    label: 'ML 430',
    parent: '3',
  },
  {
    key: '1023',
    value: 'S 280',
    label: 'S 280',
    parent: '3',
  },
  {
    key: '2695',
    value: 'S 300',
    label: 'S 300',
    parent: '3',
  },
  {
    key: '1024',
    value: 'S 320',
    label: 'S 320',
    parent: '3',
  },
  {
    key: '1025',
    value: 'S 350',
    label: 'S 350',
    parent: '3',
  },
  {
    key: '1026',
    value: 'S 500',
    label: 'S 500',
    parent: '3',
  },
  {
    key: '1028',
    value: 'S 600',
    label: 'S 600',
    parent: '3',
  },
  {
    key: '1029',
    value: 'SL 500',
    label: 'SL 500',
    parent: '3',
  },
  {
    key: '1030',
    value: 'SLK 200',
    label: 'SLK 200',
    parent: '3',
  },
  {
    key: '1031',
    value: 'SLK 230',
    label: 'SLK 230',
    parent: '3',
  },
  {
    key: '1032',
    value: 'SLK 350',
    label: 'SLK 350',
    parent: '3',
  },
  {
    key: '3021',
    value: 'SMART',
    label: 'SMART',
    parent: '3',
  },
  {
    key: '1033',
    value: 'VANEO',
    label: 'VANEO',
    parent: '3',
  },
  {
    key: '1034',
    value: 'VIANO',
    label: 'VIANO',
    parent: '3',
  },
  {
    key: '1035',
    value: 'VITO',
    label: 'VITO',
    parent: '3',
  },
  {
    key: '2290',
    value: 'ACTROS',
    label: 'ACTROS',
    parent: '2289',
  },
  {
    key: '1956',
    value: 'CBU',
    label: 'CBU',
    parent: '820',
  },
  {
    key: '1232',
    value: 'CHARIOT',
    label: 'CHARIOT',
    parent: '820',
  },
  {
    key: '2942',
    value: 'COLT',
    label: 'COLT',
    parent: '820',
  },
  {
    key: '1233',
    value: 'COLT-D',
    label: 'COLT-D',
    parent: '820',
  },
  {
    key: '1304',
    value: 'COLT-D',
    label: 'COLT-D',
    parent: '820',
  },
  {
    key: '1234',
    value: 'COLT-T',
    label: 'COLT-T',
    parent: '820',
  },
  {
    key: '2977',
    value: 'DELICAD 5',
    label: 'DELICAD 5',
    parent: '820',
  },
  {
    key: '1241',
    value: 'EMERAUDE',
    label: 'EMERAUDE',
    parent: '820',
  },
  {
    key: '2263',
    value: 'FM517H',
    label: 'FM517H',
    parent: '820',
  },
  {
    key: '2297',
    value: 'FT517VX',
    label: 'FT517VX',
    parent: '820',
  },
  {
    key: '1945',
    value: 'FU410 U',
    label: 'FU410 U',
    parent: '820',
  },
  {
    key: '2350',
    value: 'FU416U',
    label: 'FU416U',
    parent: '820',
  },
  {
    key: '1235',
    value: 'FUSO',
    label: 'FUSO',
    parent: '820',
  },
  {
    key: '3035',
    value: 'FUSO FIGHTER',
    label: 'FUSO FIGHTER',
    parent: '820',
  },
  {
    key: '2598',
    value: 'FV415J',
    label: 'FV415J',
    parent: '820',
  },
  {
    key: '2347',
    value: 'FV419J',
    label: 'FV419J',
    parent: '820',
  },
  {
    key: '1236',
    value: 'GALANT',
    label: 'GALANT',
    parent: '820',
  },
  {
    key: '1237',
    value: 'GRANDIS',
    label: 'GRANDIS',
    parent: '820',
  },
  {
    key: '1238',
    value: 'KUDA',
    label: 'KUDA',
    parent: '820',
  },
  {
    key: '1239',
    value: 'LANCER',
    label: 'LANCER',
    parent: '820',
  },
  {
    key: '2938',
    value: 'LANCER EX',
    label: 'LANCER EX',
    parent: '820',
  },
  {
    key: '1240',
    value: 'MAVEN',
    label: 'MAVEN',
    parent: '820',
  },
  {
    key: '1281',
    value: 'MIRAGE',
    label: 'MIRAGE',
    parent: '820',
  },
  {
    key: '1940',
    value: 'OUTLANDER',
    label: 'OUTLANDER',
    parent: '820',
  },
  {
    key: '1243',
    value: 'PAJERO',
    label: 'PAJERO',
    parent: '820',
  },
  {
    key: '1244',
    value: 'STRADA',
    label: 'STRADA',
    parent: '820',
  },
  {
    key: '2133',
    value: 'STRADA TRITON',
    label: 'STRADA TRITON',
    parent: '820',
  },
  {
    key: '3095',
    value: 'XPANDER',
    label: 'XPANDER',
    parent: '820',
  },
  {
    key: '1658',
    value: 'MINI COOPER',
    label: 'MINI COOPER',
    parent: '1633',
  },
  {
    key: '2463',
    value: 'CW52P',
    label: 'CW52P',
    parent: '18',
  },
  {
    key: '572',
    value: 'CWA 260',
    label: 'CWA 260',
    parent: '18',
  },
  {
    key: '2682',
    value: 'CWB 45 ALDN 10B',
    label: 'CWB 45 ALDN 10B',
    parent: '18',
  },
  {
    key: '2268',
    value: 'CWM330H',
    label: 'CWM330H',
    parent: '18',
  },
  {
    key: '1937',
    value: 'ELGRAND',
    label: 'ELGRAND',
    parent: '18',
  },
  {
    key: '1290',
    value: 'EVALIA',
    label: 'EVALIA',
    parent: '18',
  },
  {
    key: '573',
    value: 'FAIRLADY',
    label: 'FAIRLADY',
    parent: '18',
  },
  {
    key: '596',
    value: 'FRONTIER',
    label: 'FRONTIER',
    parent: '18',
  },
  {
    key: '599',
    value: 'GENESIS',
    label: 'GENESIS',
    parent: '18',
  },
  {
    key: '34',
    value: 'GRAND LIVINA',
    label: 'GRAND LIVINA',
    parent: '18',
  },
  {
    key: '2455',
    value: 'HARDTOP',
    label: 'HARDTOP',
    parent: '18',
  },
  {
    key: '576',
    value: 'INFINITY',
    label: 'INFINITY',
    parent: '18',
  },
  {
    key: '33',
    value: 'JUKE',
    label: 'JUKE',
    parent: '18',
  },
  {
    key: '577',
    value: 'LATIO',
    label: 'LATIO',
    parent: '18',
  },
  {
    key: '578',
    value: 'LIVINA',
    label: 'LIVINA',
    parent: '18',
  },
  {
    key: '35',
    value: 'MARCH',
    label: 'MARCH',
    parent: '18',
  },
  {
    key: '579',
    value: 'MURANO',
    label: 'MURANO',
    parent: '18',
  },
  {
    key: '582',
    value: 'PATHFINDER',
    label: 'PATHFINDER',
    parent: '18',
  },
  {
    key: '583',
    value: 'PATROL',
    label: 'PATROL',
    parent: '18',
  },
  {
    key: '584',
    value: 'PK',
    label: 'PK',
    parent: '18',
  },
  {
    key: '2052',
    value: 'PK 215 R',
    label: 'PK 215 R',
    parent: '18',
  },
  {
    key: '586',
    value: 'PKC',
    label: 'PKC',
    parent: '18',
  },
  {
    key: '587',
    value: 'SENTRA',
    label: 'SENTRA',
    parent: '18',
  },
  {
    key: '588',
    value: 'SERENA',
    label: 'SERENA',
    parent: '18',
  },
  {
    key: '589',
    value: 'TEANA',
    label: 'TEANA',
    parent: '18',
  },
  {
    key: '590',
    value: 'TERANNO',
    label: 'TERANNO',
    parent: '18',
  },
  {
    key: '591',
    value: 'TILDA',
    label: 'TILDA',
    parent: '18',
  },
  {
    key: '2210',
    value: 'UD CKA 87',
    label: 'UD CKA 87',
    parent: '18',
  },
  {
    key: '581',
    value: 'X-TRAIL',
    label: 'X-TRAIL',
    parent: '18',
  },
  {
    key: '592',
    value: 'Z FAIRLADY',
    label: 'Z FAIRLADY',
    parent: '18',
  },
  {
    key: '2074',
    value: 'BLAZER',
    label: 'BLAZER',
    parent: '2073',
  },
  {
    key: '2617',
    value: '206',
    label: '206',
    parent: '2026',
  },
  {
    key: '2933',
    value: '3008',
    label: '3008',
    parent: '2026',
  },
  {
    key: '2027',
    value: '306',
    label: '306',
    parent: '2026',
  },
  {
    key: '2087',
    value: '307',
    label: '307',
    parent: '2026',
  },
  {
    key: '2260',
    value: '405',
    label: '405',
    parent: '2026',
  },
  {
    key: '3018',
    value: '408',
    label: '408',
    parent: '2026',
  },
  {
    key: '2667',
    value: '806',
    label: '806',
    parent: '2026',
  },
  {
    key: '2467',
    value: '807',
    label: '807',
    parent: '2026',
  },
  {
    key: '1659',
    value: 'EXORA',
    label: 'EXORA',
    parent: '1634',
  },
  {
    key: '1660',
    value: 'GEN2',
    label: 'GEN2',
    parent: '1634',
  },
  {
    key: '1661',
    value: 'SAGA',
    label: 'SAGA',
    parent: '1634',
  },
  {
    key: '3081',
    value: 'SATRIA',
    label: 'SATRIA',
    parent: '1634',
  },
  {
    key: '1662',
    value: 'SAVVY',
    label: 'SAVVY',
    parent: '1634',
  },
  {
    key: '2194',
    value: 'K 360 IB',
    label: 'K 360 IB',
    parent: '2193',
  },
  {
    key: '2197',
    value: 'P 340 LA',
    label: 'P 340 LA',
    parent: '2193',
  },
  {
    key: '2274',
    value: 'P 380 LA',
    label: 'P 380 LA',
    parent: '2193',
  },
  {
    key: '2574',
    value: 'P 420 CB',
    label: 'P 420 CB',
    parent: '2193',
  },
  {
    key: '1663',
    value: 'EXIGA',
    label: 'EXIGA',
    parent: '1635',
  },
  {
    key: '2142',
    value: 'FORESTER',
    label: 'FORESTER',
    parent: '1635',
  },
  {
    key: '2177',
    value: 'XV',
    label: 'XV',
    parent: '1635',
  },
  {
    key: '1122',
    value: 'AERIO',
    label: 'AERIO',
    parent: '56',
  },
  {
    key: '1120',
    value: 'APV',
    label: 'APV',
    parent: '56',
  },
  {
    key: '1135',
    value: 'AVENTURA',
    label: 'AVENTURA',
    parent: '56',
  },
  {
    key: '1124',
    value: 'BALENO',
    label: 'BALENO',
    parent: '56',
  },
  {
    key: '1134',
    value: 'CARETA',
    label: 'CARETA',
    parent: '56',
  },
  {
    key: '1133',
    value: 'CARRY',
    label: 'CARRY',
    parent: '56',
  },
  {
    key: '2993',
    value: 'CELERIO',
    label: 'CELERIO',
    parent: '56',
  },
  {
    key: '1142',
    value: 'ERTIGA',
    label: 'ERTIGA',
    parent: '56',
  },
  {
    key: '1129',
    value: 'ESCUDO',
    label: 'ESCUDO',
    parent: '56',
  },
  {
    key: '1123',
    value: 'ESTEEM',
    label: 'ESTEEM',
    parent: '56',
  },
  {
    key: '1137',
    value: 'EVERY',
    label: 'EVERY',
    parent: '56',
  },
  {
    key: '2084',
    value: 'EVERY PLUS',
    label: 'EVERY PLUS',
    parent: '56',
  },
  {
    key: '1992',
    value: 'FUTURA',
    label: 'FUTURA',
    parent: '56',
  },
  {
    key: '1136',
    value: 'GRAND AVENTURA',
    label: 'GRAND AVENTURA',
    parent: '56',
  },
  {
    key: '1131',
    value: 'GRAND ESCUDO',
    label: 'GRAND ESCUDO',
    parent: '56',
  },
  {
    key: '1132',
    value: 'GRAND VITARA',
    label: 'GRAND VITARA',
    parent: '56',
  },
  {
    key: '2968',
    value: 'IGNIS',
    label: 'IGNIS',
    parent: '56',
  },
  {
    key: '1138',
    value: 'JIMNY CARRIBEAN',
    label: 'JIMNY CARRIBEAN',
    parent: '56',
  },
  {
    key: '1146',
    value: 'KARIMUN',
    label: 'KARIMUN',
    parent: '56',
  },
  {
    key: '1141',
    value: 'KARIMUN ESTILO',
    label: 'KARIMUN ESTILO',
    parent: '56',
  },
  {
    key: '2049',
    value: 'KARIMUN WAGON R',
    label: 'KARIMUN WAGON R',
    parent: '56',
  },
  {
    key: '1126',
    value: 'KATANA',
    label: 'KATANA',
    parent: '56',
  },
  {
    key: '1125',
    value: 'NEO BALENO',
    label: 'NEO BALENO',
    parent: '56',
  },
  {
    key: '1130',
    value: 'SkeyE KICK',
    label: 'SkeyE KICK',
    parent: '56',
  },
  {
    key: '1271',
    value: 'SPLASH',
    label: 'SPLASH',
    parent: '56',
  },
  {
    key: '1139',
    value: 'SWIFT',
    label: 'SWIFT',
    parent: '56',
  },
  {
    key: '1140',
    value: 'SX4',
    label: 'SX4',
    parent: '56',
  },
  {
    key: '1128',
    value: 'VITARA',
    label: 'VITARA',
    parent: '56',
  },
  {
    key: '2930',
    value: 'X OVER',
    label: 'X OVER',
    parent: '56',
  },
  {
    key: '3086',
    value: 'SUPER ACE',
    label: 'SUPER ACE',
    parent: '2282',
  },
  {
    key: '2283',
    value: 'VISTA',
    label: 'VISTA',
    parent: '2282',
  },
  {
    key: '1811',
    value: 'S',
    label: 'S',
    parent: '1810',
  },
  {
    key: '6',
    value: 'AGYA',
    label: 'AGYA',
    parent: '1',
  },
  {
    key: '61',
    value: 'ALPHARD',
    label: 'ALPHARD',
    parent: '1',
  },
  {
    key: '131',
    value: 'ALTIS',
    label: 'ALTIS',
    parent: '1',
  },
  {
    key: '7',
    value: 'AVANZA',
    label: 'AVANZA',
    parent: '1',
  },
  {
    key: '2185',
    value: 'CALYA',
    label: 'CALYA',
    parent: '1',
  },
  {
    key: '110',
    value: 'CAMRY',
    label: 'CAMRY',
    parent: '1',
  },
  {
    key: '232',
    value: 'CELICA',
    label: 'CELICA',
    parent: '1',
  },
  {
    key: '119',
    value: 'COROLLA',
    label: 'COROLLA',
    parent: '1',
  },
  {
    key: '147',
    value: 'CORONA',
    label: 'CORONA',
    parent: '1',
  },
  {
    key: '154',
    value: 'CROWN',
    label: 'CROWN',
    parent: '1',
  },
  {
    key: '284',
    value: 'DYNA',
    label: 'DYNA',
    parent: '1',
  },
  {
    key: '285',
    value: 'DYNA RINO',
    label: 'DYNA RINO',
    parent: '1',
  },
  {
    key: '246',
    value: 'ECHO',
    label: 'ECHO',
    parent: '1',
  },
  {
    key: '273',
    value: 'ESTIMA',
    label: 'ESTIMA',
    parent: '1',
  },
  {
    key: '120',
    value: 'ETIOS',
    label: 'ETIOS',
    parent: '1',
  },
  {
    key: '21',
    value: 'FORTUNER',
    label: 'FORTUNER',
    parent: '1',
  },
  {
    key: '237',
    value: 'HARRIER',
    label: 'HARRIER',
    parent: '1',
  },
  {
    key: '1392',
    value: 'HI ACE',
    label: 'HI ACE',
    parent: '1',
  },
  {
    key: '259',
    value: 'HILUX',
    label: 'HILUX',
    parent: '1',
  },
  {
    key: '272',
    value: 'IPSUM',
    label: 'IPSUM',
    parent: '1',
  },
  {
    key: '2321',
    value: 'ISIS',
    label: 'ISIS',
    parent: '1',
  },
  {
    key: '271',
    value: 'IST',
    label: 'IST',
    parent: '1',
  },
  {
    key: '193',
    value: 'KIJANG',
    label: 'KIJANG',
    parent: '1',
  },
  {
    key: '22',
    value: 'KIJANG INNOVA',
    label: 'KIJANG INNOVA',
    parent: '1',
  },
  {
    key: '1454',
    value: 'KIJANG SUPER T',
    label: 'KIJANG SUPER T',
    parent: '1',
  },
  {
    key: '183',
    value: 'LAND CRUISER',
    label: 'LAND CRUISER',
    parent: '1',
  },
  {
    key: '248',
    value: 'LEXUS',
    label: 'LEXUS',
    parent: '1',
  },
  {
    key: '180',
    value: 'LIMO',
    label: 'LIMO',
    parent: '1',
  },
  {
    key: '3001',
    value: 'MARK X',
    label: 'MARK X',
    parent: '1',
  },
  {
    key: '1413',
    value: 'NAV 1',
    label: 'NAV 1',
    parent: '1',
  },
  {
    key: '270',
    value: 'PRADO',
    label: 'PRADO',
    parent: '1',
  },
  {
    key: '225',
    value: 'PREVIA',
    label: 'PREVIA',
    parent: '1',
  },
  {
    key: '223',
    value: 'RAUM',
    label: 'RAUM',
    parent: '1',
  },
  {
    key: '215',
    value: 'RAV 4',
    label: 'RAV 4',
    parent: '1',
  },
  {
    key: '59',
    value: 'RUSH',
    label: 'RUSH',
    parent: '1',
  },
  {
    key: '2162',
    value: 'SIENTA',
    label: 'SIENTA',
    parent: '1',
  },
  {
    key: '176',
    value: 'SOLUNA',
    label: 'SOLUNA',
    parent: '1',
  },
  {
    key: '163',
    value: 'STARLET',
    label: 'STARLET',
    parent: '1',
  },
  {
    key: '1419',
    value: 'VELFIRE',
    label: 'VELFIRE',
    parent: '1',
  },
  {
    key: '1354',
    value: 'VELOZ',
    label: 'VELOZ',
    parent: '1',
  },
  {
    key: '125',
    value: 'VIOS',
    label: 'VIOS',
    parent: '1',
  },
  {
    key: '254',
    value: 'WILL',
    label: 'WILL',
    parent: '1',
  },
  {
    key: '253',
    value: 'WISH',
    label: 'WISH',
    parent: '1',
  },
  {
    key: '20',
    value: 'YARIS',
    label: 'YARIS',
    parent: '1',
  },
  {
    key: '1664',
    value: 'CW 260',
    label: 'CW 260',
    parent: '1636',
  },
  {
    key: '2247',
    value: 'PK 260',
    label: 'PK 260',
    parent: '1636',
  },
  {
    key: '2649',
    value: 'GOLF',
    label: 'GOLF',
    parent: '1995',
  },
  {
    key: '1996',
    value: 'POLO',
    label: 'POLO',
    parent: '1995',
  },
  {
    key: '2652',
    value: '960',
    label: '960',
    parent: '2206',
  },
  {
    key: '2207',
    value: 'S 80',
    label: 'S 80',
    parent: '2206',
  },
]

export default LIST_SERIES_VEHICLE